import Config from '@deezer/config';
import configContents from '@app/config/config.json';
export const config = new Config(configContents);
